import * as React from "react";
import { Link } from "@tanstack/react-router";
import { Boton, Campo, Input } from "@iavmx/ui";
import { MarcoAcceso, Mensaje } from "../componentes";
import { useSesion } from "../sesion";

/** Liga mágica por correo, solo para cuentas ya invitadas. */
export function Invitacion() {
  const { cliente, cargando, pedirLiga } = useSesion();
  const [correo, setCorreo] = React.useState("");
  const [enviadaA, setEnviadaA] = React.useState<string | null>(null);
  const [error, setError] = React.useState<string | null>(null);
  const [ocupado, setOcupado] = React.useState(false);

  async function mandar(e?: React.FormEvent) {
    e?.preventDefault();
    if (!correo.trim()) {
      setError("Escribe tu correo de Vanguardia.");
      return;
    }
    setOcupado(true);
    setError(null);
    const r = await pedirLiga(correo);
    setOcupado(false);
    if (r.error) setError(r.error);
    else setEnviadaA(correo.trim().toLowerCase());
  }

  if (enviadaA)
    return (
      <MarcoAcceso>
        <div className="space-y-5">
          <h1 className="font-titulo text-3xl font-bold leading-tight">Revisa tu correo</h1>
          <p className="font-ui text-sm text-tinta-2">
            Mandamos una liga a <b>{enviadaA}</b>. Sirve una sola vez y abre el portal directamente.
          </p>
          <Mensaje tono="ok">
            Si en unos minutos no llega, revisa la carpeta de correo no deseado. También puedes pedir otra.
          </Mensaje>
          <Boton variante="contorno" className="h-11 w-full" onClick={() => void mandar()} disabled={ocupado}>
            {ocupado ? "Mandando…" : "Mandarme otra liga"}
          </Boton>
          {error && <Mensaje tono="error">{error}</Mensaje>}
          <p className="font-ui text-xs text-tinta-tenue">Ya puedes cerrar esta pestaña.</p>
        </div>
      </MarcoAcceso>
    );

  return (
    <MarcoAcceso>
      <form className="space-y-5" onSubmit={(e) => void mandar(e)} noValidate>
        <div>
          <h1 className="font-titulo text-3xl font-bold leading-tight">Te mandamos una liga</h1>
          <p className="mt-2 font-ui text-sm text-tinta-tenue">
            Escribe el correo de Vanguardia al que llegó tu invitación. Ahí mismo te mandamos una liga para entrar sin contraseña.
          </p>
        </div>
        <Campo etiqueta="Tu correo de Vanguardia" htmlFor="correo" error={error ?? undefined}>
          <Input
            id="correo"
            type="email"
            inputMode="email"
            autoComplete="email"
            autoFocus
            className="h-11 text-base"
            placeholder="nombre@vanguardia.com.mx"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            aria-invalid={Boolean(error)}
          />
        </Campo>
        <Boton type="submit" variante="acento" className="h-11 w-full text-tinta" disabled={cargando || !cliente || ocupado}>
          {ocupado ? "Mandando…" : "Mandarme la liga"}
        </Boton>
        <Boton variante="liga" asChild>
          <Link to="/entrar">Volver a la entrada</Link>
        </Boton>
      </form>
    </MarcoAcceso>
  );
}
